import { FC, useEffect, useState } from "react";
import { IArticleSummary } from "../../../models/statistics.model";
import _ from "lodash";
import { Table, TableColumnsType } from "antd";
import { useTranslation } from "react-i18next";
import DownloadButton from "../../DownloadButton";
import moment from "moment";
import exportTable from "../../../lib/exportTable";

interface IProps {
  summaries?: IArticleSummary[];
};

const StatisticsArticleSummaryTable: FC<IProps> = ({
  summaries = [],
}) => {
  const { t } = useTranslation();

  const [data, setData] = useState<IArticleSummary[]>([]);

  useEffect(() => {
    if (summaries) {
      const courseNames = _.uniqBy(summaries, 'courseName').map(item => item.courseName);
      const newData: IArticleSummary[] = _.cloneDeep(summaries);

      courseNames.forEach(courseName => {
        const items = summaries.filter(item => item.courseName === courseName);
        const total = {
          campusCode: 'total',
          campusName: t('statistics.articles.3'),
          campusEngName: 'Total',
          courseCode: 0,
          courseName,
          postCount: _.sumBy(items, 'postCount'),
        };
        newData.unshift(total);
      });

      setData(newData);
    }
  }, [summaries]);

  const onExportTable = () => {
    exportTable(
      columns,
      data,
      `Articles(${t('statistics.attendance.Tab1')})_(${moment().format('YYYYMMDD')})`,
      `${t('statistics.attendance.Tab1')}`,
      [15, 15, 10],
    );
  };

  const columns: TableColumnsType<IArticleSummary> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusName',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column1'),
      dataIndex: 'courseName',
      align: 'center',
    },
    {
      title: 'Post',
      dataIndex: 'postCount',
      align: 'center',
    },
  ];

  return (
    <>
      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: 1,
            pageSize: 999999999,
          }}
          rowClassName={(record: IArticleSummary) => record.campusCode === 'total' ? 'tfoot' : ''}
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
      </div>
    </>
  );
};

export default StatisticsArticleSummaryTable;